import React, {Component, Fragment} from "react";

export class LoadingOverlay extends Component {

  render() {
    if (!this.props.show) return null;

    return (
      <div style={{
        textAlign: "center",
        position: "absolute",
        zIndex: 99999,
        width: !this.props.fillAvailable ? "100vh" : "-webkit-fill-available",
        height: "-webkit-fill-available",
        backgroundColor: "#FFFFFF",
        opacity: 0.25
      }}>
        <Fragment>
          <h2>Loading</h2>
          <div className="sk-three-bounce">
            <div className="sk-child sk-bounce1"></div>
            <div className="sk-child sk-bounce2"></div>
            <div className="sk-child sk-bounce3"></div>
          </div>
        </Fragment>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Shared/LoadingOverlay.js